import React from "react";
import styled from "styled-components";
import getConfig from "next/config";

import { hexToRGBA } from "../../../../../utils/theme";

const { publicRuntimeConfig } = getConfig();

const StyledOfferCard = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;

  .offer-title,
  .offer-description,
  .offer-price {
    display: flex;
    justify-content: center;
    width: 100%;
    padding: 20px;
  }

  .offer-description,
  .offer-price {
    border-left: 1px solid  ${hexToRGBA('#000000', 0.1)};
    border-right: 1px solid ${hexToRGBA('#000000', 0.1)};
  }

  .offer-title {
    background: #001e5a;
    font-family: 'Arial';
    font-weight: bold;
    font-size: 18px;
    line-height: 28px;
    text-transform: uppercase;
    color: #FFFFFF;
  }

  .offer-description {
    font-family: 'Arial';
    color: #424242;
  }

  .offer-price {
    align-items: flex-start;

    span {
      display: block;
      font-family: 'Arial';
      font-weight: bold;
      color: #001e5a;
    }

    span:first-child {
      margin-top: 6px;
      margin-right: 6px;
      font-size: 30px;
      line-height: 30px;
    }

    span:last-child {
      font-size: 72px;
      line-height: 72px;
    }
  }

  .bullets {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    width: 100%;
    padding: 20px;

    border-left: 1px solid  ${hexToRGBA('#000000', 0.1)};
    border-right: 1px solid ${hexToRGBA('#000000', 0.1)};
    border-bottom: 1px solid ${hexToRGBA('#000000', 0.1)};

    .bullet {
      display: flex;
      justify-content: flex-start;

      margin-bottom: 18px;

      .bullet-icon {
        margin-right: 10px;
      }

      .bullet-text {
        font-family: 'Arial';
        font-size: 14px;
        line-height: 24px;
        color: #424242;
      }
    }
  }
`;

function OfferCard({
  title,
  description,
  price,
  bullets = [],
}) {
  return (
    <StyledOfferCard>
      <div className="offer-title">
        <span>{title}</span>
      </div>
      <div className="offer-description">
        <span>{description}</span>
      </div>
      <div className="offer-price">
        <span>$</span>
        <span>{price}</span>
      </div>
      <div className="bullets">
        {bullets.map(bullet => (
          <div key={bullet} className="bullet">
            <div className="bullet-icon">
              <img src={`${publicRuntimeConfig.basePath}/icons/V2/V2-reflection-2/pricing_check_icon.svg`} alt="" />
            </div>
            <div className="bullet-text">
              <span>{bullet}</span>
            </div>
          </div>
        ))}
      </div>
    </StyledOfferCard>
  );
}

export default OfferCard;
